import React from "react";

// Admin Imports
import Assinantes from "views/admin/assinantes";
import Equipe from "views/admin/equipe";
import Relatorios from "views/admin/relatorios";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import { MdGroups, MdBadge, MdInsights, MdLock } from "react-icons/md";

const routes = [
  {
    name: "Assinantes",
    layout: "/admin",
    path: "assinantes",
    icon: <MdGroups className="h-6 w-6" />,
    component: <Assinantes />,
  },
  {
    name: "Relatórios",
    layout: "/admin",
    path: "relatorios",
    icon: <MdInsights className="h-6 w-6" />,
    component: <Relatorios />,
  },
  {
    name: "Equipe",
    layout: "/admin",
    path: "equipe",
    icon: <MdBadge className="h-6 w-6" />,
    component: <Equipe />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
];
export default routes;
